export const BASIC_AUTHENTICATION_ERROR = {
  REQUIRED: "{{NAME}} is required",
  NAME: "Full Name must be at least 3 characters",
  EMAIL: "Enter a valid email address",
  PASSWORD: "Password must be at least 6 characters",
  CONFIRM_PASSWORD: "Passwords must match",
  MSG_EMAIL_LENGTH: "Email should not be of more than 254 characters",
  MSG_EMAIL_USERNAME_REQ: "Email is mandatory",
  MSG_PASSWORD_TYPE: "Password must contain 8 characters",
  MSG_REQUIRED_PASSWORD: "Password is mandatory",
  AGREE_TERMS_CONDITION: "You must agree to the terms and conditions",
  SELLER_NAME_REQUIRED: "Seller name is mandatory",
  BRAND_NAME_REQUIRED: "Brand name is mandatory",
  BRAND_BIO_REQUIRED: "Brand bio is mandatory",
  BIO_REQUIRED: "Bio is mandatory",
  BUSINESS_NAME_REQUIRED: "Business name is mandatory",
  SELECT_CATEGORY_REQUIRED: "Please select an category",
  WEBSITE_MATCH:
  "Enter a valid website URL(e.g., https://example.com)",
  WEBSITE_REQUIRED: "Website is mandatory",
  CATEGORIES_REQUIRED: "Category is mandatory",
  TOTAL_QUANTITY_REQUIRED: "Total quantity is mandatory",
  QUANTITY_REQUIRED: "Quantity is mandatory",
  SIZE_REQUIRED: "Size is mandatory",
  COLOR_REQUIRED: "Color is mandatory",
  IMAGE_REQUIRED: "Image is mandatory",
  VARIENT_IMAGE_REQUIRED: "Variant image is mandatory",
  PRICE_REQUIRED: "Price is mandatory",
  TAGS_REQUIRED: "Tag is mandatory",
  DESCRIPTION_MIN_REQUIRED: "Minimum 4 characters are required",
  DESCRIPTION_MAX_REQUIRED: " Description must be 500 characters or less",
  BIO_MAX_REQUIRED: " {{name}} must be 500 characters or less",
  MANUFATURE_LOCATION_REQUIRED: "Manufacturing Location is mandatory",
  INVENTORY_STORAGE_REQUIRED: "Inventory Storage is mandatory",
  ZIP_CODE_REQUIRED: "Zip code is mandatory",
  ZIP_CODE_MAXIMUM: "Maximum number of Zip code can be 6",
  ZIP_CODE_MINIMUM: "Minimum number of Zip code can be 5",
  COUNTRY_REQUIRED: "Country is mandatory",
  STREET_ADDRESS_REQUIRED: "Street Address is mandatory",
  CITY_REQUIRED: "City is mandatory",
  STATUS_REQUIRED: "Status is mandatory",
  COLLECTIONS_REQUIRED: "Collection is mandatory",
  APPAREL_TYPE_REQUIRED: "Apparel type is mandatory",
  INSTAGRAM_MATCH: "Enter valid Instagram URL (e.g. https://instagram.com/username)",
  BASIC_URL: "Enter a valid Url(e.g., example.com)",
  MAX_CHARECTERS: "{{NAME}} name must be 50 characters or fewer.",
  PRODUCT_NAME_REQUIRED: "Product name is mandatory",
  PRICE_POSITIVE: "Price should be a positive number",
  TOTAL_QUANTITY_POSITIVE: "Total quantity should be a positive number",
  QUANTITY_POSITIVE: "Quantity should be a positive number",
  PRICE_MAX_ALLOWED: " Price must be $99999 or less",
  TOTAL_QUANTITY_MAX_LIMIT: "Total Quantity must be 0 or higher",
  QUANTITY_MAX_LIMIT: "Quantity must be between 0 and 500",
};
